import { render, staticRenderFns } from "./dynamicTable.vue?vue&type=template&id=715019dc&scoped=true&"
import script from "./dynamicTable.vue?vue&type=script&lang=js&"
export * from "./dynamicTable.vue?vue&type=script&lang=js&"
import style0 from "./dynamicTable.vue?vue&type=style&index=0&lang=css&"
import style1 from "./dynamicTable.vue?vue&type=style&index=1&id=715019dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715019dc",
  null
  
)

export default component.exports